import { LOGIN_REQUEST, UNLOGIN_REQUEST, UPDATE_LOGIN_REQUEST, SIGN_UP, ADQUIRIR_CURSO } from '../actions';
import { NotificationManager } from 'react-notifications';

export default function(state=null, action){
  switch (action.type) {
    case ADQUIRIR_CURSO:
      if (action.payload.data!==undefined && action.payload.data.id!==undefined) {
        let usuario = JSON.parse(JSON.stringify(state));
        if (usuario.cursosDisponibles!==undefined){
          usuario.cursosDisponibles.push(action.payload.data.id);
        }
        return usuario;
      }
      return state;
    case LOGIN_REQUEST:
      if (action.payload.data===undefined){
        return null;
      }
      //saber si notificar
      if (action.payload.data.notificable===undefined){
        sendNotifications(action.payload.data);
      } else {
        if(action.payload.data.notificable===1) {
          sendNotifications(action.payload.data);
        }
        delete action.payload.data.notificable;
      }
      localStorage.setItem("session_token", action.payload.data.session_token);
      return action.payload.data;
    case UNLOGIN_REQUEST:
      localStorage.setItem("session_token", null);
      NotificationManager.success('Sesión cerrada',
        'Se ha cerrado sesión exitosamente', 5000);
      return null;
    case SIGN_UP:
      if (action.payload.data === undefined){
        NotificationManager.error("Error al procesar la transacción");
        return null;
      } else if(action.payload.data.error !== undefined){
        NotificationManager.error(action.payload.data.error, "Error");
        return null;
      }

      localStorage.setItem("session_token", action.payload.data.session_token);
      return action.payload.data;
    case UPDATE_LOGIN_REQUEST:
      if (action.payload.data === undefined){
        NotificationManager.error("Error al procesar la transacción");
        return null;
      } else if(action.payload.data.error !== undefined){
        NotificationManager.error(action.payload.data.error, "Error");
        return null;
      }

      localStorage.setItem("session_token", action.payload.data.session_token);
      return action.payload.data;
    default:
      return state;
  }
}

function sendNotifications(data){
  let error_title = "Error";
  if(data.error_title!==undefined){
    error_title = data.error_title;
  }
  if (data!==null) {
    if(data.error !== undefined){
      NotificationManager.error(data.error, error_title);
    }else if(data.session_token!==null) {
      NotificationManager.success(
        `Bienvenido ${data.nombres} ${data.apellidos}`,
        'Sesión iniciada',
        5000
      );
    } else if(data.session_token!==undefined){
      NotificationManager.error('Usuario o contraseña incorrectos', 'Ups!', 5000);
    } else {
      NotificationManager.error('No hemos podido loguearlo, inténtelo denuevo más tarde', 'Error', 5000);
    }
  } else {
    NotificationManager.error("Error al procesar la transacción");
  }
}



// WEBPACK FOOTER //
// ./src/reducers/login_reducer.js